/* Karen's Helper — chat box for Karen's Variety */
(function () {
  if (customElements.get('kv-helper')) return;

  const STORE_KEY = 'kvHelperChat';
  const DEFAULT_ENDPOINT = 'https://helper.karensvariety.net';

  const CAMERA = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 8.5A1.5 1.5 0 0 1 5.5 7h2.2l1.4-2h5.8l1.4 2h2.2A1.5 1.5 0 0 1 20 8.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 17.5z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><circle cx="12" cy="12.8" r="3.3" stroke="currentColor" stroke-width="1.7"/></svg>';

  // Shrink a picture in the browser before sending (keeps it quick and cheap).
  function loadImage(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
      img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('unreadable')); };
      img.src = url;
    });
  }
  function shrink(img, max, quality) {
    const w = img.naturalWidth, h = img.naturalHeight;
    const k = Math.min(1, max / Math.max(w, h));
    const c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * k)); c.height = Math.max(1, Math.round(h * k));
    const g = c.getContext('2d');
    g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height);
    g.drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', quality);
  }

  function el(tag, cls, text) {
    const e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  class KvHelper extends HTMLElement {
    connectedCallback() {
      this.endpoint = (this.dataset.endpoint || DEFAULT_ENDPOINT).replace(/\/$/, '');
      this.product = this.dataset.product || '';
      this.persist = !this.product || this.dataset.persist === 'true';
      this.form = this.querySelector('form');
      this.input = this.querySelector('input, textarea');
      this.log = this.querySelector('[data-log]');
      this.button = this.form && this.form.querySelector('button[type=submit]');
      this.messages = this.load();
      this.busy = false;

      if (this.form) this.form.addEventListener('submit', (e) => { e.preventDefault(); this.ask(this.input.value); });
      this.querySelectorAll('[data-chip]').forEach((b) =>
        b.addEventListener('click', () => { this.input.value = b.dataset.chip; this.ask(b.dataset.chip); }));
      const reset = this.querySelector('[data-reset]');
      if (reset) reset.addEventListener('click', () => { this.messages = []; this.photo = null; this.renderChip(); this.save(); this.render(); this.input.focus(); });
      this.setupPhoto();
      this.addEventListener('kvh:refresh', () => { if (!this.busy) { this.messages = this.load(); this.render(); } });
      this.render();
    }

    /* Photos: a camera button, paste a screenshot, or drop a picture on the box. */
    setupPhoto() {
      if (!this.form || !this.input) return;
      this.photo = null;
      const btn = el('button', 'kvh-photo');
      btn.type = 'button';
      btn.title = 'Add a photo of your pattern';
      btn.setAttribute('aria-label', 'Add a photo of your pattern');
      btn.innerHTML = CAMERA;
      const file = document.createElement('input');
      file.type = 'file'; file.accept = 'image/*'; file.hidden = true;
      this.form.insertBefore(btn, this.input);
      this.form.appendChild(file);
      btn.addEventListener('click', () => file.click());
      file.addEventListener('change', () => { if (file.files && file.files[0]) this.attach(file.files[0]); file.value = ''; });
      this.input.addEventListener('paste', (e) => {
        const items = (e.clipboardData && e.clipboardData.items) ? Array.from(e.clipboardData.items) : [];
        const it = items.find((i) => i.type && i.type.indexOf('image/') === 0);
        if (it) { e.preventDefault(); this.attach(it.getAsFile()); }
      });
      this.addEventListener('dragover', (e) => { if (e.dataTransfer && Array.from(e.dataTransfer.types || []).indexOf('Files') > -1) e.preventDefault(); });
      this.addEventListener('drop', (e) => {
        const f = e.dataTransfer && Array.from(e.dataTransfer.files || []).find((x) => x.type.indexOf('image/') === 0);
        if (f) { e.preventDefault(); this.attach(f); }
      });
      this.chip = el('div', 'kvh-attach');
      this.chip.hidden = true;
      this.form.parentNode.insertBefore(this.chip, this.form);
    }
    async attach(file) {
      try {
        const img = await loadImage(file);
        this.photo = { data: shrink(img, 1600, 0.85).split(',')[1], thumb: shrink(img, 200, 0.7), sent: false };
        this.renderChip();
        if (window.matchMedia('(hover: hover)').matches) this.input.focus({ preventScroll: true });
      } catch (e) {
        this.photo = null;
        this.renderChip("Sorry, I couldn't open that picture. A photo, screenshot, JPEG or PNG works best.");
      }
    }
    renderChip(error) {
      if (!this.chip) return;
      this.chip.innerHTML = '';
      this.chip.classList.toggle('kvh-attach--error', !!error);
      if (!this.photo && !error) { this.chip.hidden = true; return; }
      if (this.photo) { const im = el('img'); im.src = this.photo.thumb; im.alt = ''; this.chip.appendChild(im); }
      this.chip.appendChild(el('span', 'kvh-attach__text', error || (this.photo.sent ? 'Still using your photo' : 'Photo added. Now ask your question.')));
      const x = el('button', 'kvh-attach__remove', error ? 'OK' : 'Remove');
      x.type = 'button';
      x.addEventListener('click', () => { this.photo = null; this.renderChip(); });
      this.chip.appendChild(x);
      this.chip.hidden = false;
    }

    load() {
      if (!this.persist) return [];
      try { return JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]').slice(-12); } catch (e) { return []; }
    }
    save() {
      if (!this.persist) return;
      try { sessionStorage.setItem(STORE_KEY, JSON.stringify(this.messages.slice(-12))); } catch (e) {}
    }

    async ask(text) {
      text = String(text || '').trim();
      if ((!text && !this.photo) || this.busy) return;
      if (!text) text = "Here's a photo from my pattern. Can you help me with it?";
      if (!this.endpoint) { this.messages.push({ role: 'user', content: text }, { role: 'assistant', content: "Karen's Helper isn't switched on yet. Please check back soon.", patterns: [] }); this.render(); return; }
      this.busy = true;
      this.input.value = '';
      const photo = this.photo;
      this.messages.push(photo && !photo.sent ? { role: 'user', content: text, thumb: photo.thumb } : { role: 'user', content: text });
      this.render(true);
      try {
        const res = await fetch(this.endpoint + '/ask', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            messages: this.messages.map((m) => ({ role: m.role, content: m.content })),
            product: this.product || undefined,
            image: photo ? { media_type: 'image/jpeg', data: photo.data } : undefined,
          }),
        });
        const data = await res.json();
        this.messages.push({ role: 'assistant', content: data.answer || 'Sorry, I have no answer for that.', patterns: data.patterns || [] });
      } catch (e) {
        this.messages.push({ role: 'assistant', content: "Sorry, I couldn't connect just now. Please try again in a moment.", patterns: [] });
      }
      this.busy = false;
      if (photo && this.photo === photo) { photo.sent = true; this.renderChip(); }
      this.save();
      this.render();
      if (window.matchMedia('(hover: hover)').matches) this.input.focus({ preventScroll: true });
    }

    render(thinking) {
      if (!this.log) return;
      this.log.innerHTML = '';
      this.classList.toggle('kv-helper--active', this.messages.length > 0 || !!thinking);
      const intro = this.querySelector('[data-intro]');
      if (intro) intro.hidden = this.messages.length > 0;
      for (const m of this.messages) {
        if (m.role === 'user') {
          const q = el('div', 'kvh-q');
          if (m.thumb) { const im = el('img', 'kvh-q__img'); im.src = m.thumb; im.alt = 'Your photo'; q.appendChild(im); }
          q.appendChild(document.createTextNode(m.content));
          this.log.appendChild(q);
        } else {
          const box = el('div', 'kvh-a');
          box.appendChild(el('div', 'kvh-a__who', "Karen's Helper"));
          m.content.split(/\n{2,}/).forEach((para) => box.appendChild(el('p', 'kvh-a__text', para)));
          if (m.patterns && m.patterns.length) {
            const grid = el('div', 'kvh-cards');
            m.patterns.forEach((p) => {
              const a = el('a', 'kvh-card');
              a.href = p.url;
              if (p.image) {
                const img = el('img');
                img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=240';
                img.alt = '';
                img.loading = 'lazy';
                a.appendChild(img);
              }
              const t = el('span', 'kvh-card__text');
              t.appendChild(el('span', 'kvh-card__title', p.title));
              t.appendChild(el('span', 'kvh-card__meta', [p.craft, '$' + p.price].filter(Boolean).join(' · ')));
              a.appendChild(t);
              grid.appendChild(a);
            });
            box.appendChild(grid);
          }
          this.log.appendChild(box);
        }
      }
      if (thinking) {
        const t = el('div', 'kvh-a kvh-a--thinking');
        t.appendChild(el('div', 'kvh-a__who', "Karen's Helper"));
        t.appendChild(el('p', 'kvh-a__text', 'Looking through the catalogue…'));
        this.log.appendChild(t);
      }
      if (this.button) this.button.disabled = !!thinking;
      // Scroll only inside the chat box (never the page) so the newest message starts in view.
      const last = this.log.lastElementChild;
      if (last && this.messages.length) {
        const d = last.getBoundingClientRect().top - this.log.getBoundingClientRect().top;
        this.log.scrollTop += d - 8;
      }
    }
  }

  customElements.define('kv-helper', KvHelper);

  /* Floating Karen's Helper: a button in the corner that opens the Helper on every page */
  const OPEN_KEY = 'kvHelperOpen';
  class KvHelperFloat extends HTMLElement {
    connectedCallback() {
      this.launcher = this.querySelector('[data-open]');
      this.panel = this.querySelector('[data-panel]');
      this.helper = this.querySelector('kv-helper');
      this.launcher.addEventListener('click', () => this.open(true));
      this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.panel.hidden) this.close(); });
      document.querySelectorAll('a[href="#helper"], a[href="/#helper"]').forEach((a) => {
        if (!document.getElementById('helper')) a.addEventListener('click', (e) => { e.preventDefault(); this.open(true); });
      });

      // The button stays visible on every page, including over the homepage Helper section.
      this.setupIntro();

      // Stay open when moving between pages (larger screens only).
      let wasOpen = false;
      try { wasOpen = sessionStorage.getItem(OPEN_KEY) === '1'; } catch (e) {}
      if (wasOpen && this.isWide()) this.open(false);
    }
    isWide() { return window.matchMedia('(min-width: 750px)').matches; }

    /* First-visit greeting: the button bobs, then a small card pops up once per visitor. */
    setupIntro() {
      this.intro = this.querySelector('[data-intro-bubble]');
      if (!this.intro) return;
      // Counts as seen once the visitor taps something on it or opens the Helper; otherwise it gets 3 tries.
      const KEY = 'kvHelperIntroSeen', SHOWN = 'kvHelperIntroShown';
      const read = (k) => { try { return localStorage.getItem(k) || sessionStorage.getItem(k); } catch (e) { return null; } };
      const write = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { try { sessionStorage.setItem(k, v); } catch (e2) {} } };
      this.markIntroSeen = () => write(KEY, '1');
      this.countIntroShown = () => write(SHOWN, String((parseInt(read(SHOWN), 10) || 0) + 1));
      this.intro.querySelectorAll('[data-intro-dismiss]').forEach((b) => b.addEventListener('click', () => { this.markIntroSeen(); this.hideIntro(); }));
      const go = this.intro.querySelector('[data-intro-open]');
      if (go) go.addEventListener('click', () => { this.hideIntro(); this.open(true); });
      let seen = read(KEY) === '1' || (parseInt(read(SHOWN), 10) || 0) >= 3;
      if (/[?&]helper-intro\b/.test(location.search)) seen = false;   // add ?helper-intro to a page address to see it again
      let chatting = false;
      try { chatting = JSON.parse(sessionStorage.getItem(STORE_KEY) || '[]').length > 0; } catch (e) {}
      if (seen || chatting) return;
      this.introPending = true;
      setTimeout(() => { this.introReady = true; this.maybeShowIntro(); }, 2500);
    }
    maybeShowIntro() {
      if (!this.introPending || !this.introReady || !this.intro) return;
      if (!this.panel.hidden || this.classList.contains('kvf--tucked')) return;
      this.introPending = false;
      this.countIntroShown();
      this.intro.hidden = false;
      this.classList.add('kvf--nudge');
      setTimeout(() => this.classList.add('kvf--intro'), 450);
    }
    hideIntro() {
      if (!this.intro || this.intro.hidden) return;
      this.intro.classList.add('kvf-intro--out');
      this.classList.remove('kvf--nudge');
      setTimeout(() => { this.intro.hidden = true; this.intro.classList.remove('kvf-intro--out'); this.classList.remove('kvf--intro'); }, 220);
    }

    open(focus) {
      if (this.markIntroSeen) this.markIntroSeen();
      this.hideIntro();
      this.introPending = false;
      this.panel.hidden = false;
      this.classList.add('kvf--open');
      this.launcher.setAttribute('aria-expanded', 'true');
      this.helper.dispatchEvent(new CustomEvent('kvh:refresh'));
      try { sessionStorage.setItem(OPEN_KEY, '1'); } catch (e) {}
      if (focus && window.matchMedia('(hover: hover)').matches) {
        const input = this.helper.querySelector('input');
        if (input) input.focus({ preventScroll: true });
      }
    }
    close() {
      this.panel.hidden = true;
      this.classList.remove('kvf--open');
      this.launcher.setAttribute('aria-expanded', 'false');
      try { sessionStorage.setItem(OPEN_KEY, '0'); } catch (e) {}
      document.querySelectorAll('kv-helper').forEach((h) => h.dispatchEvent(new CustomEvent('kvh:refresh')));
      this.launcher.focus({ preventScroll: true });
    }
  }
  customElements.define('kv-helper-float', KvHelperFloat);
})();
